// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  // apiUrl: 'http://localhost:5000/api/v1',
  // baseUrl: 'http://localhost:5000/api/v1',
  // wsUrl: 'http://localhost:8000/socket',
  apiUrl: 'https://api.alphatrend.ai/api/v1',
  baseUrl: 'https://api.alphatrend.ai/api/v1',
  wsUrl: 'https://api.alphatrend.ai/socket',

  homeUrl: 'http://localhost:4200/',
  successUrl: 'http://localhost:4200/pages/success',
  cancelUrl: 'http://localhost:4200/pages/failure',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
